module.exports = __webpack_public_path__ + "img/_gallery01.b44cb052.jpg";